import { Grid, Typography } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import { getData, storeData, callChoice } from "../../utils/GlobalHelper";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import HeaderPage from "../../components/HeaderPage/Index";
import ScrollBarComponent from "../../components/BoxRightContent/ScrollBarComponent";
import { isMobile } from "react-device-detect";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import RadioComponent from "../../components/ChoiceComponent/RadioComponent";
import CheckboxComponent from "../../components/ChoiceComponent/CheckboxComponent";
import GlobalApi from "../../utils/GlobalApi";
import Configs from "../../constants/Configs";
import DialogCustoms from "../../components/CustomDialog/DialogCustoms";
import Loading from "../../components/loading/loading";
import { API_CODE_SUCCESS } from "../../constants/CommonConstant";
import { isEmpty } from "lodash";

const useStyle = makeStyles({
  paddingTopBottom: {
    padding: "10px 0",
  },
});

const Suit10 = (props) => {
  const classes = useStyle();
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const [lang, setLang] = useState(getData("lang"));
  const [translations, setTranslations] = useState("");
  const [suitJson, setSuitJson] = useState([...getData("suit_json")]);
  const chooce = getData("chooce")?.["1"];
  const [isLoading, setIsLoading] = useState(false);
  const [isModelWait, setIsModelWait] = useState(false);
  const [isModelWaitText, setIsModelWaiText] = useState({
    title: "",
    massage: "",
    btn: "ตกลง",
  });
  const [isCheck, setIsCheck] = useState(false);
  const [jumpPage, setJumpPage] = useState(false);
  const checkuserinfo = getData("checkuserinfo");
  const questions = getData("questionsAnswer");
  const pageAgree = getData("page_agree");
  const idc = getData("idc");
  const idcAddr = getData("f2_idc_address");
  const curAddr = getData("f2_current_address");
  const workAddr = getData("f2_workplace_address");
  const docAddr = getData("f2_document_address");
  const career = getData("f3_career");
  let snapIdCard = getData("uploadImage");

  const checkJumpPage = async () => {
    await getImage();
    let productChoice = false;
    await callChoice(head_token).then((res) => {
      if (!isEmpty(res)) {
        res.forEach((e) => {
          e.items.forEach((item) => {
            if (item.selected === 1) productChoice = true;
          });
        });
      }
    });

    if (
      isEmpty(checkuserinfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1 ||
      isEmpty(snapIdCard) ||
      isEmpty(idc) ||
      isEmpty(idcAddr) ||
      isEmpty(curAddr) ||
      isEmpty(workAddr) ||
      isEmpty(docAddr) ||
      isEmpty(career) ||
      !productChoice ||
      isEmpty(suitJson)
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getImage = async () => {
    setIsLoading(true);
    var postData = {
      head_token,
    };
    const header = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const queryString = new URLSearchParams(postData).toString();
    let getImage_url = `${Configs.baseURL}/api/getupload?` + queryString;
    try {
      await GlobalApi.get(getImage_url, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res.data.api_status === "1") {
            if (res.data.data.length > 0) {
              res.data.data.forEach((element) => {
                if (element.tb_image_page === "uploadImage") {
                  snapIdCard = element.tb_image_type + element.tb_image_base64;
                }
              });
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };
  const handleNext = async () => {
    PostSuit();
  };
  const PostSuit = async () => {
    setIsLoading(true);
    storeData("suit_json", suitJson);
    try {
      let arrayJson = {
        head_token,
        suit_json: [...suitJson],
        answerjson14: [...getData("answerjson14")],
      };
      await GlobalApi.post(
        Configs.baseAPIURL03 + "/form/suitability/manp",
        arrayJson,
      )
        .then((res) => {
          setIsLoading(false);
          if (res?.status === API_CODE_SUCCESS) {
            const data = res.data.Data;
            const score = res?.data?.Data?.[1]?.[0] || {};
            const message = res?.data?.Data?.[2]?.[0] || {};
            if (isEmpty(message?.MsgDesc)) {
              if (suitJson.length === 10) {
                chooce.forEach((row, i) => {
                  if (i > 9 && i < 12) {
                    suitJson.push({
                      SAfsac_Id: 0,
                      SAfsac_SAmsa_Id: row.SAmsa_Id ? row.SAmsa_Id : "",
                      SAfsac_Answer: row.SAfsac_Answer
                        ? parseInt(row.SAfsac_Answer)
                        : "",
                      SAfsac_Score: row.SAfsac_Score
                        ? parseInt(row.SAfsac_Score)
                        : "",
                      SAfsac_SubId: row.SAfsac_SubId ? row.SAfsac_SubId : "",
                      SAfsac_SubAnswer: row.SAfsac_SubAnswer
                        ? row.SAfsac_SubAnswer
                        : "",
                      SAfsac_Remark: row.SAfsac_Remark ? row.SAfsac_Remark : "",
                      SAfsac_Remark2: row.SAfsac_Remark2
                        ? row.SAfsac_Remark2
                        : "",
                      SAfsac_Delflag: 0,
                    });
                  }
                });
                storeData("suit_json", suitJson);
              }
              props.history.push("/suit_12");
            } else {
              setIsModelWaiText({
                title: "",
                massage: message?.MsgDescTitle + "</br>" + message?.MsgDesc,
                btn: "ทำแบบประเมินอีกครั้ง",
              });
              setIsModelWait(true);
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
          setIsModelWait(true);
        });
    } catch (error) {
      setIsLoading(false);
      setIsModelWait(true);
    }
  };
  const onSetSuit = (value, key) => {
    suitJson[key].SAfsac_Answer = parseInt(value);
    suitJson[key].SAfsac_Score = parseInt(value);
    setSuitJson([...suitJson]);
  };
  const checkMax = (data) => {
    let d = data.toString().split(",");
    let max = 0;
    d.forEach((e) => {
      if (e > max) {
        max = e;
      }
    });
    return max;
  };
  const onSetSuit4 = (value, key, v) => {
    let qu = suitJson[key].SAfsac_Answer;
    let sc = suitJson[key].SAfsac_Score;
    let arr_qu = qu.toString().split("_");
    if (arr_qu.includes(v.toString())) {
      let list = "";
      arr_qu.forEach((e) => {
        if (e.toString() !== v.toString())
          list = !isEmpty(list) ? list + "_" + e : e;
      });
      suitJson[key].SAfsac_Answer = list;
      suitJson[key].SAfsac_Score = checkMax(list);
    } else {
      suitJson[key].SAfsac_Answer = qu.toString() ? qu.toString() + "_" + v : v;
      suitJson[key].SAfsac_Score = checkMax(qu.toString() + "_" + v);
    }
    setSuitJson([...suitJson]);
  };
  const checkChoiceSuit = () => {
    let check = 0;
    suitJson.forEach((suit, i) => {
      if (
        suit.SAfsac_Answer.toString() !== "0" &&
        suit.SAfsac_Answer.toString() !== ""
      ) {
        check++;
      }
    });
    if (check > 9) {
      setIsCheck(true);
    } else {
      setIsCheck(false);
    }
  };
  useEffect(() => {
    checkJumpPage().then((res) => {
      if (res) setJumpPage(true);
    });
  }, []);
  useEffect(() => {
    checkChoiceSuit();
  }, [suitJson]);
  useEffect(() => {
    storeData("suit", true);
    const translation = getData("Translations");
    if (!isEmpty(translation)) {
      setTranslations(translation);
    } else {
      props.history.push("/");
    }
  }, []);
  return (
    <>
      {jumpPage ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <HeaderPage
            title={translations?.[lang]?.suit?.title}
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) => (e ? props.history.push("/suit") : "")}
          />
          <DialogCustoms
            imgModalError
            open={isModelWait}
            isModel={setIsModelWait}
            title={isModelWaitText?.title}
            massage={isModelWaitText?.massage}
            btnPrimary={isModelWaitText?.btn}
            switchType={(e) => {
              if (e) {
                props.history.push("/suit");
              }
            }}
          />
          <Loading status={isLoading} />
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.suit}
                        clickBack={(e) => props.history.push("/suit")}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={isMobile ? 16 : 9}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid className="content-main">
                        <Grid
                          className="box-right-content pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                          }}
                        >
                          {" "}
                          <HeaderRight
                            title={translations?.[lang]?.suit?.title}
                          />
                          <ScrollBarComponent
                            content={
                              <>
                                <Grid>
                                  <Grid>
                                    <Typography className="text-primary font-weight-bold font-20">
                                      {
                                        translations?.[lang]?.suit
                                          ?.suit_question_title_10
                                      }
                                    </Typography>
                                  </Grid>
                                  <Grid
                                    className={clsx(
                                      "font-DBHeavent",
                                      "font-18",
                                      classes.paddingTopBottom,
                                    )}
                                  >
                                    {
                                      translations?.[lang]?.suit
                                        ?.suit_question_description_10
                                    }
                                  </Grid>
                                  <Grid>
                                    {chooce?.map(
                                      (items, i) =>
                                        i < 10 && (
                                          <Grid key={i}>
                                            <Grid
                                              className={clsx(
                                                "font-DBHeavent",
                                                "font-20",
                                                "text-primary",
                                              )}
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  lang === "en"
                                                    ? items?.SAmsa_EnQuestion
                                                    : items?.SAmsa_Question,
                                              }}
                                            />
                                            {i !== 3 ? (
                                              <RadioComponent
                                                suitJson={suitJson?.[i]}
                                                choice={
                                                  lang === "en"
                                                    ? JSON.parse(
                                                        items?.SAmsa_EnAnswer,
                                                      )
                                                    : JSON.parse(
                                                        items?.SAmsa_Answer,
                                                      )
                                                }
                                                handleChange={(e) => {
                                                  onSetSuit(e.target.value, i);
                                                }}
                                              />
                                            ) : (
                                              <CheckboxComponent
                                                suitJson={suitJson?.[i]}
                                                choice={
                                                  lang === "en"
                                                    ? JSON.parse(
                                                        items?.SAmsa_EnAnswer,
                                                      )
                                                    : JSON.parse(
                                                        items?.SAmsa_Answer,
                                                      )
                                                }
                                                handleChange={(e, v) => {
                                                  onSetSuit4(
                                                    e.target.value,
                                                    i,
                                                    v,
                                                  );
                                                }}
                                              />
                                            )}
                                          </Grid>
                                        ),
                                    )}
                                  </Grid>
                                </Grid>
                              </>
                            }
                          />{" "}
                          <ButtonRight
                            isDisbled
                            disbled={isCheck}
                            text={translations?.[lang]?.suit?.next}
                            onNextPage={handleNext}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};
export default memo(Suit10);
